export type SavedChatSummary = {
  id: number;
  title: string;
  updated_at: string;
};

export const CHAT_GROUP_LABELS = [
  'Today',
  'Yesterday',
  'Previous 7 days',
  'Older',
] as const;

export type ChatGroupLabel = (typeof CHAT_GROUP_LABELS)[number];

export type ChatGroup = {
  label: ChatGroupLabel;
  chats: SavedChatSummary[];
};

const startOfDay = (date: Date) => {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start;
};

export const groupSavedChats = (
  chats: SavedChatSummary[],
  now: Date = new Date(),
): ChatGroup[] => {
  const today = startOfDay(now);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const previousWeek = new Date(today);
  previousWeek.setDate(previousWeek.getDate() - 7);

  const buckets: Record<ChatGroupLabel, SavedChatSummary[]> = {
    Today: [],
    Yesterday: [],
    'Previous 7 days': [],
    Older: [],
  };

  [...chats]
    .sort(
      (left, right) =>
        new Date(right.updated_at).getTime() -
        new Date(left.updated_at).getTime(),
    )
    .forEach((chat) => {
      const updated = new Date(chat.updated_at);
      if (Number.isNaN(updated.getTime()) || updated >= today) {
        buckets.Today.push(chat);
      } else if (updated >= yesterday) {
        buckets.Yesterday.push(chat);
      } else if (updated >= previousWeek) {
        buckets['Previous 7 days'].push(chat);
      } else {
        buckets.Older.push(chat);
      }
    });

  return CHAT_GROUP_LABELS.filter((label) => buckets[label].length > 0).map(
    (label) => ({ label, chats: buckets[label] }),
  );
};
